/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_PreviousInputs */

const en_idea_previous = /** @type {(inputs: Idea_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved plans`)
};

const id_idea_previous = /** @type {(inputs: Idea_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana tersimpan`)
};

/**
* | output |
* | --- |
* | "Saved plans" |
*
* @param {Idea_PreviousInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_previous = /** @type {((inputs?: Idea_PreviousInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_PreviousInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_previous(inputs)
	return en_idea_previous(inputs)
});